<template>
  <div class="home">
    <h1 class="my-4 text-h5 font-weight-bold text-center">
      {{ person.姓名 }}您好，以下是您的預約資訊
    </h1>
    <v-row justify="center" class="mt-4" v-if="section">
      <v-col class="col-auto text-h6">
        <div>日期: {{ section.日期 }}</div>
        <div>時間: {{ section.開始時間 }}-{{ section.結束時間 }}</div>
        <div class="error--text font-weight-bold mb-4 text-body-2 text-center">
          (請於時間內報到)
        </div>
        <div class="error--text font-weight-bold mb-4">
          建議報到時間: {{ person.建議時間 }}
        </div>

        <div>地點: {{ section.地點 }}</div>
        <div v-if="section.地址">地址: {{ section.地址 }}</div>
      </v-col>
    </v-row>
    <div
      class="text-center text-body-2 red--text text--lighten-1 font-weight-bold"
    >
      (您可以截圖、複製上方文字或列印本頁，以方便記憶。)
    </div>
    <template
      v-if="
        section && (section.整合式篩檢 || section.顯示問卷) && !person.外部問卷
      "
    >
      <div class="text-center font-weight-bold text-h5 mt-4">
        為節省您健康檢查當日寶貴的時間<br />建議先行填寫下方問卷
      </div>
      <div class="text-center text-h5">
        <a
          target="_blank"
          rel="noopener"
          :href="`${surveyURL}?aka_name=${person.姓名}&aka_id=${person.身分證字號}`"
        >
          問卷連結
        </a>
      </div>
      <div
        class="text-center text-body-2 red--text text--lighten-1 font-weight-bold"
      >
        (建議您將此連結記錄下來，若有閒暇時間即可填寫，可以加速當天健康檢查流程。)
      </div>
    </template>
    <div class="mt-8 mb-4 text-h5 font-weight-bold text-center">
      當天務必攜帶
    </div>
    <v-row justify="center" class="text-h6">
      <v-col class="col-auto mx-2">
        <v-icon large color="green darken-2" class="mr-2 mb-1">
          mdi-checkbox-marked-outline </v-icon
        >健保卡
      </v-col>
      <v-col class="col-auto mx-2">
        <v-icon large color="green darken-2" class="mr-2 mb-1">
          mdi-checkbox-marked-outline </v-icon
        >身份證
      </v-col>
    </v-row>
    <div class="mt-8 text-h5 font-weight-bold text-center">
      您當天的檢查項目<br />(依現場查詢實際資格為主，部分診所酌收掛號費)
    </div>
    <v-row class="mt-4 mx-0" justify="center">
      <v-col class="col-auto" v-for="(value, key) of validItem" :key="key">
        <div class="mb-4">
          <v-img
            contain
            max-height="50"
            :src="items[key].logo"
            alt=""
          ></v-img>
        </div>
        <div class="font-weight-bold text-h6 text-center">
          {{ items[key].title }}
          <div v-if="key == '成健'" class="text-button error--text">
            (請空腹8小時)
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col class="col-auto">
        <v-btn
          @click="addEvent"
          class="mt-2 px-12"
          large
          outlined
          color="warning"
        >
          <v-icon left>mdi-calendar</v-icon>
          加入行事曆
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col class="col-auto">
        <v-btn
          @click="cancel"
          class="mt-2 px-12"
          x-large
          color="error"
          :disabled="cancelDisabled"
          >取消預約</v-btn
        >
      </v-col>
      <v-col
        class="col-auto"
        v-if="
          section &&
          (section.整合式篩檢 || section.顯示問卷) &&
          !person.外部問卷
        "
      >
        <a
          target="_blank"
          rel="noopener"
          :href="`${surveyURL}?aka_name=${person.姓名}&aka_id=${person.身分證字號}`"
        >
          <v-btn class="mt-2 px-12" x-large color="success">填寫問卷</v-btn>
        </a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { 健檢項目 } from "@/libs/const.js";
import _ from "lodash";
import dayjs from "dayjs";
import { surveyURL } from "@/../env.js";
import addGoogleEvent from "@/libs/addGoogleEvent";
export default {
  name: "Confirm",
  data: () => ({
    valid: false,
    person: null,
    section: null,
    items: 健檢項目,
    surveyURL,
  }),
  computed: {
    validItem() {
      return _.pickBy(this.person.篩檢項目, (value) => value);
    },
    cancelDisabled() {
      return dayjs() > dayjs(this.person.日期);
    },
  },
  async created() {
    this.person = { ...this.$store.state.person };
    if (
      !this.person.日期 ||
      (this.person.日期 &&
        this.person.篩檢項目 &&
        dayjs() > dayjs(this.person.日期).add(1, "day") &&
        !this.person.篩檢項目.成健) ||
      (this.person.日期 && dayjs() > dayjs(this.person.日期).add(8, "day"))
    ) {
      this.$router.push("/quick/ItemCheck");
      return false;
    }
    this.section = (await this.axios.get(`/section/${this.person.場次}`)).data;
  },
  methods: {
    addEvent: async function () {
      addGoogleEvent({
        name: "健康篩檢",
        start_datetime: this.person.日期 + " " + this.person.開始時間,
        end_datetime: this.person.日期 + " " + this.person.結束時間,
        location: this.person.地點,
      });
    },

    cancel: async function () {
      if (confirm("確認要取消預約？")) {
        try {
          await this.axios.post("/cancel", { person: this.person });
          delete this.person.地點;
          delete this.person.日期;
          this.$store.commit("setState", { person: this.person });
          this.$router.push("/quick");
          this.$toast.success("取消預約成功！");
        } catch (e) {
          console.log(e);
          this.$toast.error("取消失敗！");
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.item-checkbox {
  width: 230px;
}
</style>
